import React from "react";
import { Helmet } from "react-helmet-async";

const SettingsHeader = (props) => {
  const { page } = props;

  return (
    <div className="settings-header">
      <Helmet>
        <title>{page ? `U.GG - ${page}` : "U.GG - Settings"}</title>
      </Helmet>
      <h1>Settings</h1>
      {page && <h2>{page}</h2>}
    </div>
  );
};

export default SettingsHeader;
